export default __webpack_public_path__ + "static/media/Spin torre RD_Interactive LightMix0041.34d8a121.webp";